import "./App.css";
import Navbar from "./components/navbar/Navbar";
import NameForm from "./components/nameForm/NameForm";

function App() {
  return (
    <div className="app">
      <Navbar />
      <NameForm />
    </div>
  );
}

export default App;
